// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"786ad7bc","397":"a13b37d2","488":"544e6d57"}[chunkId] + ".chunk.js";
};